module.exports = __webpack_public_path__ + "static/media/dummy-avatar.5e4a8264.svg";